import { type TerminalColor } from './terminal';
import * as types from './types';

export const UnknownContextKey = 'unknown_key';

export const LoggerOptionDefaults = {
  isEnabled: true,
  level: types.LogLevel.Trace,
  pretty: true,
  timeFormat: 'LLL dd yyyy HH:mm:ss',
} as const satisfies Partial<types.LoggerOptions>;

export const DataDogRumApplicableLevels = [types.LogLevel.Error, types.LogLevel.Warn] as const;

export type DataDogRumApplicableLevel = (typeof DataDogRumApplicableLevels)[number];

export const isDataDogApplicableForLevel = (
  level: types.LogLevel,
): level is DataDogRumApplicableLevel =>
  DataDogRumApplicableLevels.includes(level as DataDogRumApplicableLevel);

export const LogLevelColors: Record<'unknown' | types.LogLevel, TerminalColor> = {
  debug: 'gray',
  error: 'red',
  info: 'cyan',
  trace: 'gray',
  unknown: 'red',
  warn: 'yellow',
};

/* eslint-disable no-console */
export const ConsoleWriters: Record<types.LogLevel, typeof console.log> = {
  debug: console.debug,
  error: console.error,
  info: console.info,
  trace: console.info,
  warn: console.warn,
};
/* eslint-enable no-console */
